import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDSTYvhWEbwEqWsrTrW9-RxxlZNu1dP_QM",
  authDomain: "aa-play-eed53.firebaseapp.com",
  projectId: "aa-play-eed53",
  storageBucket: "aa-play-eed53.firebasestorage.app",
  messagingSenderId: "458916804534",
  appId: "1:458916804534:web:09cc1fc9fc90fff5dc7317",
  measurementId: "G-8SPRKWVVKM",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1");
export const storage = getStorage(app);
